import styled from "styled-components";
import { Box } from "@material-ui/core";
import { ToggleButton as MaterialToggleButton } from "@material-ui/lab";
import { orange } from "@material-ui/core/colors";

export const FormLine = styled(Box)`
    width: 100%;
    padding: ${({ theme }) => theme.spacing(1)}px;
    margin: ${({ theme }) => theme.spacing(1)}px;
`;

export const ToggleButton = styled(MaterialToggleButton)`
    text-transform: capitalize;
    border-color: ${orange["300"]};

    &.Mui-selected {
        color: white;
        background-color: ${orange["300"]};

        &:hover {
            background-color: ${orange["700"]};
        }
    }

    &:hover {
        background-color: ${orange["700"]};
        color: white;
    }
`;
